import {InjectionToken} from '@angular/core';

export const TISA_MEDIA_LIBRARY_URL = new InjectionToken<string>(
  'Provides base url of Media Library API.',
);

export const TISA_MEDIA_LIBRARY_TOKEN = new InjectionToken<string>(
  'Provides token for Media Library API authorization.',
);
